import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { TSelectValues } from '@private/components';

import { PER_PAGE_OPTIONS } from 'constants/common';
import { appReactMemo } from 'hocs';
import { useBreakpoint } from 'hooks/adaptive/useBreakpoint';
import { useSaveUserConfigParam } from 'queries/portalUser';

import { Container, StyledAutoCompleteSelect, Text } from './styled';

interface IItemsPerPage {
  className?: string;
  onChange?: (page: number) => void;
  value?: number;
}

const ItemsPerPage: React.FC<IItemsPerPage> = ({ className, onChange, value = 10 }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'common.pagination' });

  const checkWindowWidth = useBreakpoint();

  const { mutate: saveRecordsPerPage } = useSaveUserConfigParam();

  const onSelectValue = useCallback(
    (value: TSelectValues | TSelectValues[]) => {
      const recordsPerPage = value as number;
      onChange?.(recordsPerPage);
      saveRecordsPerPage({ recordsPerPage });
    },
    [onChange, saveRecordsPerPage],
  );

  return (
    <Container className={className}>
      <Text size='sm' variant='bold'>
        {t('itemsPerPage')}
      </Text>
      <StyledAutoCompleteSelect
        enablePortal
        enableRemoveButton={false}
        onChange={onSelectValue}
        options={PER_PAGE_OPTIONS}
        selectOnly
        size={checkWindowWidth(1000) ? 'md' : 'lg'}
        testIds={{ root: 'perPageSelect' }}
        value={value}
      />
    </Container>
  );
};

export default appReactMemo(ItemsPerPage);
